import { Box } from "@bca/ui-library";
import styled, { keyframes } from "styled-components";
import {
  border,
  BorderProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
} from "styled-system";

interface SkeletonProps extends SpaceProps, LayoutProps, BorderProps {
  animationDuration?: number;
}

const loadAnimation = keyframes`
  0% {
    left: -200%;
  }
  100% {
    left: 100%;
  }
`;

const StyledSkeleton = styled(Box)<SkeletonProps & PositionProps>`
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: -200%;
    top: 0;
    height: 100%;
    width: 200%;
    background: linear-gradient(
      to right,
      #d8e1e8 0%,
      #f1f4f6 50%,
      #d8e1e8 100%
    );
    animation: ${loadAnimation} ${(props) => props.animationDuration}s
      ease-in-out infinite;
  }
  ${border}
  ${space}
  ${layout}
  ${position}
`;

const AnimatedBox: React.FunctionComponent<SkeletonProps> = ({
  width,
  height,
  animationDuration = 2,
  ...rest
}) => (
  <StyledSkeleton
    data-testid="my-skeleton"
    borderRadius={1}
    backgroundColor="#d8e1e8"
    overflow="hidden"
    position="relative"
    animationDuration={animationDuration}
    width={width}
    height={height}
    {...rest}
  />
);

export default AnimatedBox;
